import { apiFetch } from "@/integrations/backend/client";

export interface OnboardingData {
  id?: string | null;
  gender?: string | null;
  dob?: string | null; // ISO date string (yyyy-MM-dd)
  heightFeet?: number | null;
  heightInches?: number | null;
  heightCm?: number | null;
  heightUnit?: "imperial" | "metric" | null;
  bodyWeight?: number | null;
  weightUnit?: "lb" | "kg" | null;
  motivation?: string[]; // array of MotivationChoices codes
  goals?: string[];
  activityLevel?: string | null; // ActivityLevelChoices code
  workoutFrequency?: string | null; // WorkoutFrequencyChoices code
  workoutDuration?: string | null; // Workout duration (30-min, 45-min, 60-plus-min)
  location?: string[]; // array of LocationChoices codes
  exerciseTypes?: string[]; // array of ExerciseTypeChoices codes
  sportsEnjoyed?: string | null;
  variety?: string | null;
  healthConditions?: string | null;
  injuries?: string | null;
  fitnessLevel?: string | null; // FitnessLevelChoices code
  successMetrics?: string[]; // array of SuccessMetricChoices codes
  gymPersona?: string[]; // array of GymPersonaChoices codes
  resultTimeframe?: string | null; // ResultTimeframeChoices code
  specificGoals?: Record<string, string>;
  currentMetrics?: Record<string, string>;
  additionalServices?: string[]; // array of AdditionalServiceChoices codes
  trainingForEvent?: string | null; // "yes" or "no"
  eventDetails?: string | null;
  eventDate?: string | null; // ISO date string (yyyy-MM-dd)
  selectedPlan?: string | null;
  billingCycle?: "monthly" | "annual" | null; // BillingCycleChoices code
  equipmentIds?: string[];
  workoutPlanPdfUrl?: string | null;
}

export async function getOnboarding(): Promise<OnboardingData> {
  const res = await apiFetch("/api/v1/onboarding/me", {
    method: "GET",
  });
  if (!res.ok) {
    throw new Error(`get_onboarding_failed:${res.status}`);
  }
  return await res.json();
}

export async function saveOnboarding(data: Partial<OnboardingData>): Promise<void> {
  const res = await apiFetch("/api/v1/onboarding/me", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    throw new Error(`save_onboarding_failed:${res.status}`);
  }
}

